import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { CAPTAINS } from "@/content/galaxy";
import { RevealedCard, LockedCard } from "@/components/CaptainCards";

export const CaptainsTeaser = () => {
  const revealed = CAPTAINS.list;
  const remaining = Math.max(CAPTAINS.count - revealed.length, 0);
  const progressPct = Math.round((revealed.length / CAPTAINS.count) * 100);

  return (
    <section
      id="captains"
      data-testid="captains-section"
      className="relative z-10 py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="font-mono-accent text-xs uppercase tracking-[0.3em] text-gl-blue2">
            {CAPTAINS.badge}
          </span>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-5xl">
            {CAPTAINS.headline}
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-white/65 sm:text-base">
            {CAPTAINS.intro}
          </p>

          {/* Enthüllungs-Fortschritt */}
          <div className="mx-auto mt-8 max-w-xs">
            <div className="flex items-center justify-between font-mono-accent text-[10px] uppercase tracking-[0.24em] text-white/45">
              <span>Enthüllung</span>
              <span data-testid="captains-progress-label">
                {revealed.length} / {CAPTAINS.count} enthüllt
              </span>
            </div>
            <div className="mt-2 h-1 w-full overflow-hidden rounded-full bg-white/10">
              <motion.div
                initial={{ width: 0 }}
                whileInView={{ width: `${progressPct}%` }}
                viewport={{ once: true }}
                transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                className="h-full rounded-full bg-brand-gradient"
              />
            </div>
          </div>
        </Reveal>

        <div data-testid="captains-grid" className="mt-14 grid grid-cols-2 gap-4 sm:mt-16 sm:gap-6 lg:grid-cols-4">
          {revealed.map((c, i) => (
            <RevealedCard key={c.name} captain={c} index={i} />
          ))}
          {Array.from({ length: remaining }, (_, k) => (
            <LockedCard key={`locked-${k}`} index={revealed.length + k} />
          ))}
        </div>
      </div>
    </section>
  );
};
